import { Button } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { useOrganization } from 'hooks';
import { t } from 'i18next';
import { first } from 'lodash';
import ReactJson from 'react-json-view';
import IOrganization from 'types/Organization';

export interface IOrganizationSettingsDetailsProps {
  className?: string | object;
  onClose: () => void;
}

const OrganizationSettingsDetails = (props: IOrganizationSettingsDetailsProps) => {
  const { className, onClose } = props;

  const organization = useOrganization();

  const classes = classNames('m-6', className);

  const getTrimmedOrganizationObject = (org: IOrganization) => {
    return {
      createdOn: org.createdOn,
      authoritativeSignature: org.authoritativeSignature,
      budgets: {
        trackBudget: org.trackBudgets,
        trackBudgetCost: org.trackBudgetCost,
        trackBudgetEquipmentCosts: org.trackBudgetEquipmentCosts,
        trackBudgetEquipmentHours: org.trackBudgetEquipmentHours,
        trackBudgetProgress: org.trackBudgetProgress,
        trackBudgetProgressValue: org.trackBudgetProgressValue,
      },
      defaults: {
        defaultBreakDuration: org.defaultBreakDuration,
        defaultEndTime: org.defaultEndTime,
        defaultStartTime: org.defaultStartTime,
      },
      demo: org.demo,
      disclaimer: org.disclaimer,
      inRecoveryMode: org.inRecoveryMode,
      lockOnSelfSignature: org.lockOnSelfSignature,
      minimumAppVersion: org.minimumAppVersion,
      organizationInfo: org.organizationInfo,
      organizationPayPeriod: first(org.organizationPayPeriod),
      organizationOvertimePreiods: first(org.organizationOvertimePeriods),
      organizationName: org.organizationName,
      overtimeFlag: org.overtimeFlag,
      requireCostCode: org.requireCostCode,
      requireProject: org.requireProject,
      safety: {
        enabled: org.safetySignature,
        safetySignatureMessage: org.safetySignatureMessage,
        signatureDate: org.signatureDate,
      },
      breaks: {
        enabled: org.breakPolicy,
        breakPolicyCalifornia: org.breakPolicyCalifornia,
        breakPolicyMessage: org.breakPolicyMessage,
      },
      timeAccuracy: {
        enabled: org.timeAccuracy,
        timeAccuracyMessage: org.timeAccuracyMessage,
      },
      timeRounding: {
        enabled: org.timeRounding,
        timeRoundingInterval: org.timeRoundingInterval,
        timeRoundingType: org.timeRoundingType,
      },
      totalTimeFlag: org.totalTimeFlag,

      useProjectCostCodeScoping: org.useProjectCostCodeScoping,
      webGps: org.webGps,
      busySignInQuestion: org.busySignInQuestion,
      hideUnassignedProjects: org.hideUnassignedSubprojects,
      timeOffRequests: org.timeOffRequests,
      subscriptionStatus: org.subscriptionStatus,
    };
  };

  return (
    <div className={classes}>
      <div>
        <h3>{t('Current Organization settings')}</h3>
        <ReactJson name={'Organization'} collapsed={true} src={getTrimmedOrganizationObject(organization) ?? {}} />
      </div>
      <div className="mt-5">
        <Button onClick={onClose} type="secondary" className={'mt-4'}>
          {t('Close')}
        </Button>
      </div>
    </div>
  );
};

export default OrganizationSettingsDetails;
